export const CRUD_UPDATE_BREAD = "CRUD_BREAD";
export const CRUD_UPDATE_SEARCH = "CRUD_SEARCH";
export const CRUD_SEARCH_RESET = "CRUD_SEARCH_RESET";
export const CRUD_EXPORT_ACTION = "CRUD_EXPORT_ACTION";
export const CRUD_UPDATE_MODAL= "CRUD_UPDATE_MODAL";
export const CRUD_SEARCH_SHOW= "CRUD_SEARCH_SHOW";

